/**** 常量數據 ****/
export const ORG_CODE = '1051'
export const ORG_NAME = '台南應用科技大學'

export const SYS_COPYRIGHT = 'Copyright@2026 台南應用科技大學 版權所有'

export const SORT_FIELD_NAME = 'NA'
export const SORT_UP_DOWN = 'UP'
export const PAGE_SIZE = 10

/* 課程地圖API */
export const COURSEMAP_API_URL = 'https://coursemap.tut.edu.tw/ap'

/**** 系統名稱 ****/

/* (內部)測試連結 npm run build*/
// export const CLIENT_URL = 'http://localhost'
// export const API_BASE = 'http://localhost:61254'
// export const DEFAULT_IMAGE_URL = 'http://localhost:61254'
// export const SYS_MANUAL_URL = ''

export const AI_API_GENERATE_URL = 'https://chat-ai.tut.edu.tw:11435/api/generate'
export const AI_API_CHAT_URL = 'https://chat-ai.tut.edu.tw:11435/api/chat'

////////////////////////////////

/* 遠距教學管考系統 Distance Learning System */
// export const SYS_CODE = 'RTS'
// export const SYS_NAME = '遠距教學管考系統'
// export const SYS_INFO = '[業務推展]教務處課務組(TEL：#387)'
// export const SYS_INFO_OUT = '業務推展：教務處課務組TEL:#387'
// export const SYS_VERSION = 'RTS-Ver1.0.0'

// export const CLIENT_URL = 'https://distancelearning.tut.edu.tw'  
// export const API_BASE = 'https://rtsap.tut.edu.tw'
// export const DEFAULT_IMAGE_URL = 'https://rtsap.tut.edu.tw'
// export const SYS_MANUAL_URL = ''

/*
<appSettings>
  <add key="schoolWebAPI" value="https://netapi.tut.edu.tw" />
  <add key="ClientIP" value="https://distancelearning.tut.edu.tw/sso" />
  <add key="SystemCode" value="RTS" />
  <add key="SystemVersion" value="RTS-Ver1.0.0" />
</appSettings>
*/

////////////////////////////////////////////////////////////////////////

/* 職工出缺勤管理系統 Punch InOut Manage System */
// export const SYS_CODE = 'PIM'
// export const SYS_NAME = '職工出缺勤管理系統'
// export const SYS_INFO = '[業務推展]人事室(TEL：#224)'
// export const SYS_INFO_OUT = '業務推展：人事室(人事服務組) TEL:#224'
// export const SYS_VERSION = 'PIM-Ver1.0.0'

// export const CLIENT_URL = 'https://punchinout.tut.edu.tw'  
// export const API_BASE = 'https://pimap.tut.edu.tw'
// export const DEFAULT_IMAGE_URL = 'https://pimap.tut.edu.tw'
// export const SYS_MANUAL_URL = ''

/*
<appSettings>
  <add key="schoolWebAPI" value="https://netapi.tut.edu.tw" />
  <add key="ClientIP" value="https://punchinout.tut.edu.tw/sso" />
  <add key="SystemCode" value="PIM" />
  <add key="SystemVersion" value="PIM-Ver1.0.0" />
</appSettings>
*/

///////////////////////////////////////////////////////////////////////
/* 生源規劃管理系統 Student Source Plan*/
// export const SYS_CODE = 'SSP'
// export const SYS_NAME = '生源規劃管理系統'
// export const SYS_INFO = '[業務推展]招生策進中心(鄭敬橙先生-TEL#354、#366)'
// export const SYS_INFO_OUT = '業務推展：招生策進中心 TEL:#354、#366'
// export const SYS_VERSION = 'SSP-Ver1.0.0'

// export const CLIENT_URL = 'https://ssp.tut.edu.tw'
// export const API_BASE = 'https://sspap.tut.edu.tw'
// export const DEFAULT_IMAGE_URL = 'https://sspap.tut.edu.tw'
// export const SYS_MANUAL_URL = 'https://www.canva.com/design/DAF-JZpz_cM/CqAF3JQrQY1JIhkcebHmiA/view?utm_content=DAF-JZpz_cM&utm_campaign=designshare&utm_medium=link&utm_source=editor'

/*
<appSettings>
  <add key="schoolWebAPI" value="https://netapi.tut.edu.tw" />
  <add key="ClientIP" value="https://ssp.tut.edu.tw/sso" />
  <add key="SystemCode" value="SSP" />
  <add key="SystemVersion" value="SSP-Ver1.0.0" />
</appSettings>
*/

///////////////////////////////////////////////////////////////////////
/* Self Study AI System */
// export const SYS_CODE = 'APC'
// export const SYS_NAME = 'AI輔助教學暨自主學習平台'
// export const SYS_INFO = '[業務推展] 圖資中心(TEL：283)'
// export const SYS_INFO_OUT = '業務推展：圖資中心(行政組) TEL:062432728'
// export const SYS_VERSION = 'APC-Ver1.0.0'

// export const CLIENT_URL = 'https://selfstudy-ai.tut.edu.tw'
// export const API_BASE = 'https://apsap.tut.edu.tw'
// export const DEFAULT_IMAGE_URL = 'https://apsap.tut.edu.tw'
// export const SYS_MANUAL_URL = ''

/*
<appSettings>
  <add key="schoolWebAPI" value="https://netapi.tut.edu.tw" />
  <add key="ClientIP" value="http://selfstudy-ai.tut.edu.tw/sso" />
  <add key="SystemCode" value="APC" />
  <add key="SystemVersion" value="APC-Ver1.0.0" />
</appSettings>
*/

////////////////////////////////

/* NotebookLM Manage System */
// export const SYS_CODE = 'NMS'
// export const SYS_NAME = '校園知識共享平台(TUT筆記雲)'
// export const SYS_INFO = '[業務推展]圖資中心(TEL：#283)'
// export const SYS_INFO_OUT = '業務推展：圖資中心 TEL:#283'
// export const SYS_VERSION = 'NMS-Ver1.0.0'

// export const CLIENT_URL = 'https://notebooklm-ai.tut.edu.tw'  
// export const API_BASE = 'https://nmsap.tut.edu.tw'
// export const DEFAULT_IMAGE_URL = 'https://nmsap.tut.edu.tw'
// export const SYS_MANUAL_URL = ''

/*
<appSettings>
  <add key="schoolWebAPI" value="https://netapi.tut.edu.tw" />
  <add key="ClientIP" value="https://notebooklm-ai.tut.edu.tw/sso" />
  <add key="SystemCode" value="NMS" />
  <add key="SystemVersion" value="NMS-Ver1.0.0" />
</appSettings>
*/

//// AI APP系列-修課建議
// export const SYS_CODE = 'I01'
// export const SYS_NAME = 'AI修課建議APP'
// export const SYS_INFO = '[業務推展] 圖資中心(TEL：283)'
// export const SYS_INFO_OUT = '業務推展：圖資中心(行政組) TEL:062432728'
// export const SYS_VERSION = 'I01-Ver1.0.0'

// export const CLIENT_URL = 'https://app001-ai.tut.edu.tw'
// export const API_BASE = 'https://app001ap-ai.tut.edu.tw'
// export const DEFAULT_IMAGE_URL = 'https://app001ap-ai.tut.edu.tw '
// export const SYS_MANUAL_URL = ''

/*
<appSettings>
  <add key="schoolWebAPI" value="https://netapi.tut.edu.tw" />
  <add key="ClientIP" value="http://app001-ai.tut.edu.tw/sso" />
  <add key="SystemCode" value="I01" />
  <add key="SystemVersion" value="I01-Ver1.0.0" />
</appSettings>
*/

///////////////////////////////////////////////////////////////////////
/* 休假查詢系統Holiday Status Search System */
// export const SYS_CODE = 'HSS'
// export const SYS_NAME = '教職員休假查詢系統'
// export const SYS_INFO = '[業務推展]人事室(TEL：062535645)'
// export const SYS_INFO_OUT = '業務推展：人事室(人事服務組) TEL:062535645'
// export const SYS_VERSION = 'HSS-Ver1.0.0'
// export const SYS_MANUAL_URL = ''

// export const CLIENT_URL = 'https://holidaystatussearch.tut.edu.tw'
// export const API_BASE = 'https://hssap.tut.edu.tw'
// export const DEFAULT_IMAGE_URL = 'https://hssap.tut.edu.tw'
// export const SYS_MANUAL_URL = ''

/*
<appSettings>
  <add key="schoolWebAPI" value="https://netapi.tut.edu.tw" />
  <add key="ClientIP" value="https://holidaystatussearch.tut.edu.tw/sso" />
  <add key="SystemCode" value="HSS" />
  <add key="SystemVersion" value="HSS-Ver1.0.0" />
</appSettings>
*/

///////////////////////////////////////////////////////////////////////
/* UCAN結果查詢系統 UCAN Result Search System*/
// export const SYS_CODE = 'URS'
// export const SYS_NAME = 'UCAN結果查詢系統'
// export const SYS_INFO = '[業務推展]職涯發展中心(TEL：062421971)'
// export const SYS_INFO_OUT = '業務推展：研發處(職涯發展中心) TEL:062421971'
// export const SYS_VERSION = 'URS-Ver1.0.0'
// export const SYS_MANUAL_URL = ''

// export const CLIENT_URL = 'https://ucanresultsearchui.tut.edu.tw'
// export const API_BASE = 'https://ucanresultsearchap.tut.edu.tw'
// export const DEFAULT_IMAGE_URL = 'https://ucanresultsearchap.tut.edu.tw'
// export const SYS_MANUAL_URL = ''

/*
<appSettings>
  <add key="schoolWebAPI" value="https://netapi.tut.edu.tw" />
  <add key="ClientIP" value="https://ucanresultsearchui.tut.edu.tw/sso" />
  <add key="SystemCode" value="URS" />
  <add key="SystemVersion" value="URS-Ver1.0.0" />
</appSettings>
*/

///////////////////////////////////////////////////////////////////////
/* 校友家族助學金申請系統 Alumni Family Scholarships System*/
// export const SYS_CODE = 'AFS'
// export const SYS_NAME = '校友家族獎助金申請系統'
// export const SYS_INFO = '[業務推展]秘書室(楊孟潔小姐-TEL#206)'
// export const SYS_INFO_OUT = '業務推展：秘書室校友組 TEL:#206'
// export const SYS_VERSION = 'AFS-Ver1.0.0'
// export const SYS_MANUAL_URL = ''

// export const CLIENT_URL = 'https://afs.tut.edu.tw'
// export const API_BASE = 'https://afsap.tut.edu.tw'
// export const DEFAULT_IMAGE_URL = 'https://afsap.tut.edu.tw'

/*
<appSettings>
  <add key="schoolWebAPI" value="https://netapi.tut.edu.tw" />
  <add key="ClientIP" value="https://afs.tut.edu.tw/sso" />
  <add key="SystemCode" value="AFS" />
  <add key="SystemVersion" value="AFS-Ver1.0.0" />
</appSettings>
*/

///////////////////////////////////////////////////////////////////////
/* 教學品保系統 Teaching Quailty Assurance*/
// export const SYS_CODE = 'TQA'
// export const SYS_NAME = '教學品保管理系統'
// export const SYS_INFO = '[業務推展]教務處教發中心(洪致瑩小姐-TEL#344、#345) || [系統開發]圖資中心(曾秋榮先生-TEL#261)'
// export const SYS_INFO_OUT = '業務推展：教務處(教發中心) TEL:#344、#345'
// export const SYS_VERSION = 'TQA-Ver1.0.0'
//export const SYS_MANUAL_URL = ''

// export const CLIENT_URL = 'https://teachingqa.tut.edu.tw'
// export const API_BASE = 'https://teachingqaap.tut.edu.tw'
// export const DEFAULT_IMAGE_URL = 'https://teachingqaap.tut.edu.tw'
// export const SYS_MANUAL_URL = ''

/*
<appSettings>
  <add key="schoolWebAPI" value="https://netapi.tut.edu.tw" />
  <add key="ClientIP" value="https://teachingqa.tut.edu.tw/sso" />
  <add key="SystemCode" value="TQA" />
  <add key="SystemVersion" value="TQA-Ver1.0.0" />
</appSettings>
*/

///////////////////////////////////////////////////////////////////////
/* 應屆畢業生調查系統(GraduateFrash Alumni Management)
05月-08月 login 南應大入口帳密
09月 login 身份證字號/生日西元年月日
*/
// export const SYS_CODE = 'GAM'
// export const SYS_NAME = '應屆畢業生調查系統'
// export const SYS_INFO = '[業務推展]職涯發展中心(TEL：062421971)'
// export const SYS_INFO_OUT = '業務推展：研發處(職涯發展中心) TEL:062421971'
// export const SYS_VERSION = 'GAM-Ver1.0.0'

// export const CLIENT_URL = 'https://freshgraduateui.tut.edu.tw'
// export const API_BASE = 'https://freshgraduateap.tut.edu.tw'
// export const DEFAULT_IMAGE_URL = 'https://freshgraduateap.tut.edu.tw'
// export const SYS_MANUAL_URL = ''

/*
<appSettings>
  <add key="schoolWebAPI" value="https://netapi.tut.edu.tw" />
  <add key="ClientIP" value="https://freshgraduateui.tut.edu.tw/sso" />
  <add key="SystemCode" value="GAM" />
  <add key="SystemVersion" value="GAM-Ver1.0.0" />
</appSettings>
*/

///////////////////////////////////////////////////////////////////////
/* 畢業生流向調查系統(Graduate Statistical Management) */
// export const SYS_CODE = 'GQM'
// export const SYS_NAME = '畢業生流向調查系統'
// export const SYS_INFO = '[業務推展]職涯發展中心(TEL:06-2421971)'
// export const SYS_INFO_OUT = '業務推展：研發處(職涯發展中心) TEL:062421971'
// export const SYS_VERSION = 'GQM-Ver1.0.1'
// export const SYS_MANUAL_URL = ''

// export const CLIENT_URL = 'https://surveygraduateui.tut.edu.tw'
// export const API_BASE = 'https://surveygraduateap.tut.edu.tw'
// export const DEFAULT_IMAGE_URL = 'https://surveygraduateap.tut.edu.tw'

/*
<appSettings>
  <add key="schoolWebAPI" value="https://netapi.tut.edu.tw" />
  <add key="ClientIP" value="https://surveygraduateui.tut.edu.tw/sso" />
  <add key="SystemCode" value="GQM" />
  <add key="SystemVersion" value="GQM-Ver1.0.0" />
</appSettings>
*/

///////////////////////////////////////////////////////////////////////
/* 校友服務管理系統(Alumni Management System )*/
export const SYS_CODE = 'AMS'
export const SYS_NAME = '校友資訊系統'
export const SYS_INFO = '[業務推展]秘書室校友服務組(林容慧小姐-TEL#206)'
export const SYS_INFO_OUT = '業務推展：秘書室(校友服務組) TEL:06-2544400'
export const SYS_VERSION = 'AMS-Ver1.0.0'


export const CLIENT_URL = 'https://alumniui.tut.edu.tw'
export const API_BASE = 'https://alumniap.tut.edu.tw'
export const DEFAULT_IMAGE_URL = 'https://alumniap.tut.edu.tw'
export const SYS_MANUAL_URL = ''

/*
<appSettings>
  <add key="schoolWebAPI" value="https://netapi.tut.edu.tw" />
  <add key="ClientIP" value="https://alumniui.tut.edu.tw/sso" />
  <add key="SystemCode" value="AMS" />
  <add key="SystemVersion" value="AMS-Ver1.0.0" />
</appSettings>
*/

///////////////////////////////////////////////////////////////////////
/* 學生賃居調查系統 */
// export const SYS_CODE = 'SLM'
// export const SYS_NAME = '學生賃居調查系統'
// export const SYS_INFO = '[業務推展]學務處生輔組(張志宏先生-TEL#222)'
// export const SYS_INFO_OUT = '業務推展：學務處(生活輔導組) TEL:#222'
// export const SYS_VERSION = 'SLM-Ver2.1.0'


// export const CLIENT_URL = 'https://renthouseui.tut.edu.tw'
// export const API_BASE = 'https://renthouseap.tut.edu.tw'
// export const DEFAULT_IMAGE_URL = 'https://renthouseap.tut.edu.tw'
// export const SYS_MANUAL_URL = ''

/*
<appSettings>
  <add key="schoolWebAPI" value="https://netapi.tut.edu.tw" />
  <add key="ClientIP" value="https://renthouseui.tut.edu.tw/sso" />
  <add key="SystemCode" value="SLM" />
  <add key="SystemVersion" value="SLM-V2.1.0" />
</appSettings>
*/

/////////////////////////////////////////////////////////////////////
/* 語文學習點數管理系統 */
// export const SYS_CODE = 'ECA'
// export const SYS_NAME = '語文學習點數管理系統'
// export const SYS_INFO = '[業務推展]語文訓練中心(林昱辰小姐-TEL#286)'
// export const SYS_INFO_OUT = '業務推展：語文訓練中心 TEL:#286'
// export const SYS_VERSION = 'ECA-Ver1.1.0'

// export const CLIENT_URL = 'https://learnpointsui.tut.edu.tw'
// export const API_BASE = 'https://learnpointsap.tut.edu.tw'
// export const DEFAULT_IMAGE_URL = 'https://learnpointsap.tut.edu.tw'
// export const SYS_MANUAL_URL = ''

/*
<appSettings>
  <add key="schoolWebAPI" value="https://netapi.tut.edu.tw" />
  <add key="ClientIP" value="https://learnpointsui.tut.edu.tw/sso" />
  <add key="SystemCode" value="ECA" />
  <add key="SystemVersion" value="ECA-Ver1.1.0" />
</appSettings>
*/

///////////////////////////////////////////////////////////////////////
/* 夜間進出校園登記系統 Gate Security Management(gate) NSM*/
// export const SYS_CODE = 'GSM'
// export const SYS_NAME = '校園進出管理系統'
// export const SYS_INFO = '[業務推展]總務處事務組(林新涵先生-TEL#268)'
// export const SYS_INFO_OUT = '業務推展：總務處事務組 TEL:#268'
// export const SYS_VERSION = 'GSM-Ver1.0.0'
// export const SYS_MANUAL_URL = ''

// export const CLIENT_URL = 'https://gatesecurity.tut.edu.tw'
// export const API_BASE = 'https://gatesecurityap.tut.edu.tw'
// export const DEFAULT_IMAGE_URL = 'https://gatesecurityap.tut.edu.tw'
// export const SYS_MANUAL_URL = ''

/*
<appSettings>
  <add key="schoolWebAPI" value="https://netapi.tut.edu.tw" />
  <add key="ClientIP" value="https://gatesecurity.tut.edu.tw/sso" />
  <add key="SystemCode" value="GSM" />
  <add key="SystemVersion" value="GSM-Ver1.0.0" />
</appSettings>
*/

/////////////////////////////////////////////////////////////////////
/* 數位歷程檔案(electronic portfolio system)*/
// export const SYS_CODE = 'EPS'
// export const SYS_NAME = '數位歷程檔案'
// export const SYS_INFO = '[業務推展]圖書與資訊中心網路作業組(柯祈宏先生-TEL#283)'
// export const SYS_INFO_OUT = '業務推展：圖書與資訊中心 TEL:#283'
// export const SYS_VERSION = 'EPS-Ver1.0.0'

// export const CLIENT_URL = 'https://eportfolio.tut.edu.tw'
// export const API_BASE = 'https://eportfolioap.tut.edu.tw'
// export const DEFAULT_IMAGE_URL = 'https://eportfolioap.tut.edu.tw'
// export const SYS_MANUAL_URL = ''

/*
<appSettings>
  <add key="schoolWebAPI" value="https://netapi.tut.edu.tw" />
  <add key="ClientIP" value="https://eportfolio.tut.edu.tw/sso" />
  <add key="SystemCode" value="EPS" />
  <add key="SystemVersion" value="EPS-Ver1.0.0" />
</appSettings>
*/

///////////////////////////////////////////////////////////////////////
/* 校園空間管理系統 University Space Management*/
// export const SYS_CODE = 'USM'
// export const SYS_NAME = '校園空間管理系統'
// export const SYS_INFO = '[業務推展]總務處保管組(張至豪組長-TEL#258)'
// export const SYS_INFO_OUT = '業務推展：總務處保管組 TEL:#258'
// export const SYS_VERSION = 'USM-Ver1.0.0'
// export const SYS_MANUAL_URL = ''

// export const CLIENT_URL = 'https://spacemanagementui.tut.edu.tw'
// export const API_BASE = 'https://spacemanagementap.tut.edu.tw'
// export const DEFAULT_IMAGE_URL = 'https://spacemanagementap.tut.edu.tw'
// export const SYS_MANUAL_URL = ''

/*
<appSettings>
  <add key="schoolWebAPI" value="https://netapi.tut.edu.tw" />
  <add key="ClientIP" value="https://spacemanagementui.tut.edu.tw/sso" />
  <add key="SystemCode" value="USM" />
  <add key="SystemVersion" value="USM-Ver1.0.0" /> 
</appSettings>
*/

///////////////////////////////////////////////////////////////////////
/* 電腦教室報修系統(Computer Fix System) */
// export const SYS_CODE = 'CFS'
// export const SYS_NAME = '電腦教室設備報修系統'
// export const SYS_INFO = '[業務推展]圖書與資訊中心網路作業組(鄭景文先生-TEL#261)'
// export const SYS_INFO_OUT = '業務推展：圖書與資訊中心(網路作業組) TEL:#261'
// export const SYS_VERSION = 'CFS-Ver1.0.0'
// export const SYS_MANUAL_URL = ''

// export const CLIENT_URL = 'https://fixcomputerui.tut.edu.tw'
// export const API_BASE = 'https://fixcomputerap.tut.edu.tw'
// export const DEFAULT_IMAGE_URL = 'https://fixcomputerap.tut.edu.tw'
// export const SYS_MANUAL_URL = ''

/*
<appSettings>
  <add key="schoolWebAPI" value="https://netapi.tut.edu.tw" />
  <add key="ClientIP" value="https://fixcomputerui.tut.edu.tw/sso" />
  <add key="SystemCode" value="CFS" />
  <add key="SystemVersion" value="CFS-Ver1.0.0" />   
</appSettings>
*/

///////////////////////////////////////////////////////////////////////
/* 教材上網統計系統(Teaching Material Search) */
// export const SYS_CODE = 'TMS'
// export const SYS_NAME = '教材上網統計'
// export const SYS_INFO = '[業務推展]圖書與資訊中心網路作業組(柯祈宏先生-TEL#283)'
// export const SYS_INFO_OUT = '業務推展：圖書與資訊中心 TEL:#283'
// export const SYS_VERSION = 'TMS-Ver1.0.0'
// export const SYS_MANUAL_URL = ''

// export const CLIENT_URL = 'https://teachingmaterial.tut.edu.tw'
// export const API_BASE = 'https://teachingmaterialap.tut.edu.tw'
// export const DEFAULT_IMAGE_URL = 'https://teachingmaterialap.tut.edu.tw'
// export const SYS_MANUAL_URL = ''

/*
<appSettings>
  <add key="schoolWebAPI" value="https://netapi.tut.edu.tw" />
  <add key="ClientIP" value = "https://teachingmaterial.tut.edu.tw/sso" />
  <add key="SystemCode" value = "TMS" />
  <add key="SystemVersion" value="TMS-Ver1.0.0" />
</appSettings>
*/

///////////////////////////////////////////////////////////////////////
/* 文創作品管理系統 */
// export const SYS_CODE = 'CCW'
// export const SYS_NAME = '師生文創作品管理系統'
// export const SYS_INFO = '[業務推展]圖書與資訊中心網路作業組(柯祈宏先生-TEL#283)'
// export const SYS_INFO_OUT = '業務推展：圖書與資訊中心 TEL:#283'
// export const SYS_VERSION = 'CCW-Ver1.0.0'
// export const SYS_MANUAL_URL = ''

// export const CLIENT_URL = 'https://ccworksui.tut.edu.tw'
// export const API_BASE = 'https://ccworksap.tut.edu.tw'
// export const DEFAULT_IMAGE_URL = 'https://ccworksap.tut.edu.tw'
// export const SYS_MANUAL_URL = ''

/*
<appSettings>
  <add key="schoolWebAPI" value="https://netapi.tut.edu.tw" />
  <add key="ClientIP" value="https://ccworksui.tut.edu.tw/sso" />
  <add key="SystemCode" value="CCW" />
  <add key="SystemVersion" value="CCW-Ver1.0.0" />
</appSettings>
*/

///////////////////////////////////////////////////////////////////////
/* 資訊素養測驗系統 Information Literacy Assessment System*/
// export const SYS_CODE = 'ILA'
// export const SYS_NAME = '資訊素養測驗統計系統'
// export const SYS_INFO = '[業務推展]通識教育中心(張原豪先生-TEL#350)'
// export const SYS_INFO_OUT = '業務推展：通識教育中心 TEL:#350'
// export const SYS_VERSION = 'ILA-Ver1.0.0'
// export const SYS_MANUAL_URL = ''

// export const CLIENT_URL = 'https://ila.tut.edu.tw'
// export const API_BASE = 'https://ilaap.tut.edu.tw'
// export const DEFAULT_IMAGE_URL = 'https://ilaap.tut.edu.tw'
// export const SYS_MANUAL_URL = ''

/*
<appSettings>
  <add key="schoolWebAPI" value="https://netapi.tut.edu.tw" />
  <add key="ClientIP" value="https://ila.tut.edu.tw/sso" />
  <add key="SystemCode" value="ILA" />
  <add key="SystemVersion" value="ILA-Ver1.0.0" />
</appSettings>
*/

///////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////
/* 國圖串接 */
/* 
<add key="schoolWebAPI" value="https://netapi.tut.edu.tw" />
<add key="ClientIP" value="https:/libwebpac.tut.edu.tw/hysso/GetToken" />
<add key="SystemCode" value="SSS" />
<add key="SystemVersion" value="SSS-Ver1.0.0" /> 
*/

/* 空間使用查核系統 */
// export const SYS_CODE = 'LRS'
// export const SYS_NAME = '空間使用查核系統'
// export const SYS_INFO = '[業務推展]圖書與資訊中心網路作業組(柯祈宏先生-TEL#283)'
// export const SYS_INFO_OUT = '業務推展：圖書與資訊中心 TEL:#283'
// export const SYS_VERSION = 'LRS-Ver1.0.0'
// export const SYS_MANUAL_URL = ''

// export const CLIENT_URL = 'https://spacelendui.tut.edu.tw'
// export const API_BASE = 'https://spacelendap.tut.edu.tw'
// export const DEFAULT_IMAGE_URL = 'https://spacelendsap.tut.edu.tw'
// export const SYS_MANUAL_URL = ''

/*
<appSettings>
  <add key="schoolWebAPI" value="https://netapi.tut.edu.tw" />
  <add key="ClientIP" value="https://spacelendui.tut.edu.tw/sso" />
  <add key="SystemCode" value="LRS" />
  <add key="SystemVersion" value="LRS-Ver1.0.0" /> 
</appSettings>
*/

///////////////////////////////////////////////////////////////////////
/* 領取獎項管理系統(Awards Reservation System) */
// export const SYS_CODE = 'ARS'  
// export const SYS_NAME = '領取獎項預約系統'
// export const SYS_INFO = '[業務推展]學務處生活輔導組(侯雅庭小姐-TEL#222)'
// export const SYS_INFO_OUT = '業務推展：學務處(生活輔導組) TEL:#222'
// export const SYS_VERSION = 'ARS-Ver1.0.0'
// export const SYS_MANUAL_URL = ''

// export const CLIENT_URL = 'https://awardsreservationui.tut.edu.tw'
// export const API_BASE = 'https://awardsreservationap.tut.edu.tw'
// export const DEFAULT_IMAGE_URL = 'https://awardsreservationap.tut.edu.tw'
// export const SYS_MANUAL_URL = ''

/*
<appSettings>
  <add key="schoolWebAPI" value="https://netapi.tut.edu.tw" />
  <add key="ClientIP" value = "https://awardsreservationui.tut.edu.tw/sso" />
  <add key="SystemCode" value = "ARS" />
</appSettings>
*/

///////////////////////////////////////////////////////////////////////
/* 主管決策支援系統 (DSS, Decision Support System) */
// export const SYS_CODE = 'DSS'
// export const SYS_NAME = '主管決策支援系統'
// export const SYS_INFO = '[系統開發]圖書與資訊中心(曾秋榮先生-TEL#261)'
// export const SYS_INFO_OUT = ''
// export const SYS_VERSION = 'DSS-Ver1.0.0'
// export const SYS_MANUAL_URL = ''

// export const CLIENT_URL = 'https://decisionsupportui.tut.edu.tw'
// export const API_BASE = 'https://decisionsupportap.tut.edu.tw'
// export const DEFAULT_IMAGE_URL = 'https://decisionsupportap.tut.edu.tw'
// export const SYS_MANUAL_URL = ''

/*
<appSettings>
  <add key="schoolWebAPI" value="https://netapi.tut.edu.tw" />
  <add key="ClientIP" value="https://decisionsupportui.tut.edu.tw/sso" />
  <add key="SystemCode" value="DSS" />
  <add key="SystemVersion" value="DSS-Ver1.0.0" />   
</appSettings>
*/

///////////////////////////////////////////////////////////////////////
/* 服務諮詢系統(One Stop Service) */
// export const SYS_CODE = 'OSS'
// export const SYS_NAME = '服務諮詢系統'
// export const SYS_INFO = '[業務推展]圖書與資訊中心網路作業組(柯祈宏先生-TEL#283) || [系統開發]圖書與資訊中心(曾秋榮先生-TEL#261)'
// export const SYS_INFO_OUT = '業務推展：圖書與資訊中心 TEL:#283'
// export const SYS_VERSION = 'OSS-Ver1.0.0'
// export const SYS_MANUAL_URL = ''

// export const CLIENT_URL = 'https://linebotservice.tut.edu.tw'
// export const API_BASE = 'https://linebotserviceapi.tut.edu.tw'
// export const DEFAULT_IMAGE_URL = 'https://linebotserviceapi.tut.edu.tw'
// export const SYS_MANUAL_URL = ''

/*
<appSettings>
  <add key="schoolWebAPI" value="https://netapi.tut.edu.tw" />
  <add key="ClientIP" value="https://linebotservice.tut.edu.tw/sso" />
  <add key="SystemCode" value="OSS" />
  <add key="SystemVersion" value="OSS-Ver1.0.0" /> 
</appSettings>
*/

///////////////////////////////////////////////////////////////////////
/* Line貼圖比賽官網*/
// export const SYS_CODE = 'WEB'
// export const SYS_NAME = '「TUT虛擬數位形象大使」徵稿票選活動'
// export const SYS_INFO = '指導單位-校長室、主辦單位-通識中心、協辦單位-視傳系、漫畫系、多動系、圖書與資訊中心、秘書室'
// export const SYS_INFO_OUT = '業務推展：通識中心'
// export const SYS_VERSION = 'WEB-Ver Line'
// export const SYS_MANUAL_URL = ''

// export const CLIENT_URL = 'https://contestsignupui.tut.edu.tw'
// export const API_BASE = 'https://contestsignupap.tut.edu.tw'
// export const DEFAULT_IMAGE_URL = 'https://contestsignupap.tut.edu.tw'
// export const SYS_MANUAL_URL = ''

///////////////////////////////////////////////////////////////////////
/* 徵稿報名系統(Contest Survey Lottery)*/
// export const SYS_CODE = 'CSLC'
// export const SYS_NAME = '徵稿報名系統'
// export const SYS_INFO = '[業務推展]推廣中心 || [系統開發]圖書與資訊中心(曾秋榮先生-TEL#261)'
// export const SYS_INFO_OUT = '業務推展：推廣中心'
// export const SYS_VERSION = 'CSLC-Ver1.0.0'
// export const SYS_MANUAL_URL = ''

// export const CLIENT_URL = 'https://contestsignupui.tut.edu.tw'
// export const API_BASE = 'https://contestsignupap.tut.edu.tw'
// export const DEFAULT_IMAGE_URL = 'https://contestsignupap.tut.edu.tw'
// export const SYS_MANUAL_URL = ''

/*
<appSettings>
  <add key="schoolWebAPI" value="https://netapi.tut.edu.tw" />
  <add key="ClientIP" value="https://contestsignupui.tut.edu.tw/sso" />
  <add key="SystemCode" value="CSLC" />
  <add key="SystemVersion" value="CSLC-Ver1.0.0" />
</appSettings>

*/
/* 票選抽獎系統(Contest Survey Lottery)*/
// export const SYS_CODE = 'CSLL'
// export const SYS_NAME = '票選抽獎系統'
// export const SYS_INFO = '[業務推展]推廣中心 || [系統開發]圖書與資訊中心(曾秋榮先生-TEL#261)'
// export const SYS_INFO_OUT = '業務推展：推廣中心'
// export const SYS_VERSION = 'CSLL-Ver1.0.0'
// export const SYS_MANUAL_URL = ''

// export const CLIENT_URL = 'https://surveyui.tut.edu.tw'
// export const API_BASE = 'https://surveyap.tut.edu.tw'
// export const DEFAULT_IMAGE_URL = 'https://contestsignupap.tut.edu.tw'
// export const SYS_MANUAL_URL = ''

/*
<appSettings>
  <add key="schoolWebAPI" value="https://netapi.tut.edu.tw" />
  <add key="ClientIP" value="https://surveyui.tut.edu.tw/sso" />
  <add key="SystemCode" value="CSLL" />
  <add key="SystemVersion" value="CSLL-Ver1.0.0" />
</appSettings>
*/
///////////////////////////////////////////////////////////////////////
/*競賽活動報名系統*/
/*
// export const SYS_CODE = 'ERS'
// export const SYS_NAME = '競賽活動報名系統'
// export const SYS_INFO = '[業務推展]圖書與資訊中心網路作業組(柯祈宏先生-TEL#283) || [系統開發]圖書與資訊中心(曾秋榮先生-TEL#261)'
// export const SYS_INFO_OUT = '業務推展：圖書與資訊中心 TEL:#283'
// export const SYS_VERSION = 'ERS-Ver1.0.0'
*/
///////////////////////////////////////////////////////////////////////
/* RealName Space Management */
// export const SYS_CODE = 'RNS'   
// export const SYS_NAME = '實名制資訊系統'
// export const SYS_INFO = '[業務推展]由圖書與資訊中心(曾秋榮先生-TEL#261) || [系統開發]由圖書與資訊中心(曾秋榮先生-TEL#261)'
// export const SYS_INFO_OUT = '業務推展：圖書與資訊中心(雲端應用組) TEL:#261'
// export const SYS_VERSION = 'RNS-Ver1.0.0'
///////////////////////////////////////////////////////////////////////
/* Guest Car Management */
// export const SYS_CODE = 'CAR'
// export const SYS_NAME = '外賓車輛管理系統'
// export const SYS_INFO = '[業務推展]總務處事務組(林新涵先生-TEL#223) || [系統開發]圖書與資訊中心(曾秋榮先生-TEL#261)'
// export const SYS_INFO_OUT = '業務推展：總務處事務組 TEL:#223'
// export const SYS_VERSION = 'CAR-Ver1.0.0'
///////////////////////////////////////////////////////////////////////
/* Equipment Repair Management */
// export const SYS_CODE = 'FIX'
// export const SYS_NAME = '設備修繕管理系統'
// export const SYS_INFO =  '[業務推展]總務處營繕組(洪佳星先生-TEL#268) || [系統開發]圖書與資訊中心(曾秋榮先生-TEL#261)'
// export const SYS_INFO_OUT = '業務推展：總務處營繕組 TEL:#268'
// export const SYS_VERSION = 'FIX-Ver1.0.0'
///////////////////////////////////////////////////////////////////////
/* 選舉投票管理系統 */
// export const SYS_CODE = 'EVS'  
// export const SYS_NAME = '選舉投票管理系統'
// export const SYS_INFO = '[業務推展]學務處(組) || [系統開發]圖書與資訊中心(曾秋榮先生-TEL#261)'
// export const SYS_INFO_OUT = '業務推展：學務處(組) TEL:#222'
// export const SYS_VERSION = 'EVS-Ver1.0.0'

// export const CLIENT_URL = 'https://electionvoteui.tut.edu.tw'
// export const API_BASE = 'https://electionvoteap.tut.edu.tw'
// export const DEFAULT_IMAGE_URL = 'https://electionvoteap.tut.edu.tw'

//<appSettings>
//  <add key="schoolWebAPI" value = "https://netapi.tut.edu.tw" />
//  <add key="ClientIP" value = "https://electionvoteui.tut.edu.tw/sso" />
//  <add key="SystemCode" value = "EVS" />
//</appSettings>
///////////////////////////////////////////////////////////////////////

export const BASE_IMG_URL = API_BASE + '/upload/'